// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__EkFuD","block":"styles_block__DFsFW","active":"styles_active__R5kNc"};